<template>
  <main class="sa-content sa-booking-detl">
    <div class="sa-card-large">
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">{{$route.query.app_stat == 4 ? 'Completed order details' : 'My appointments' }}</h5>
        <button class="sa-btn-back" @click="$router.go(-1)">
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <div class="sa-mob-cont" v-if="aptDetails">
        <div class="sa-new-details">
          <AppointmentListCard :data="aptDetails" />
          <HealthIssues :voiceNote="aptDetails.voice_note" :textNote="aptDetails.note" />
        </div>
        <PatientDetails :patientData="patientData" :sampleStatus="aptDetails.is_sample_collected"
          @toggle-status="toggleStatus" />
        <SummeryNote v-model="parentTextareaValue" v-if="!aptDetails.is_sample_collected" />
        <div class="sa-text-right">
          <button v-if="!aptDetails.is_sample_collected" class="sa-btn sa-btn-primary sa-btn-large sa-mt20"
            @click="completeService">Complete service</button>
        </div>
      </div>
      <div v-else>
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
      </div>
    </div>
  </main>
</template>
<script>
import AppointmentListCard from "../../components/nurse/AppointmentListCard.vue";
import HealthIssues from "../../components/nurse/HealthIssues.vue";
import PatientDetails from "../../components/nurse/PatientDetails.vue";
import SummeryNote from "../../components/nurse/SummeryNote.vue";
import { lab_url, nurse_url } from "../../../config/endpoints";
import ContentLoader from "../../components/common/ContentLoader.vue";
export default {
  components: { AppointmentListCard, HealthIssues, PatientDetails, SummeryNote, ContentLoader },
  data() {
    return {
      parentTextareaValue: '',
      open: false,
      aptDetails: null,
      patientData: []
    };
  },
  mounted() {
    this.utid = JSON.parse(this.$localStorage.get("utid"))
    this.ptnDetails()
  },
  methods: {
    toggleStatus(value) {
      this.pat_available = value
    },
    completeService() {
      this.api = this.utid === 4 ? `${lab_url}/appointment/update` : `${nurse_url}/appointment/update`
      let aptData = this.aptDetails
      let obj = {
        apnt_id: aptData.apnt_id,
        is_multi_patient: aptData.is_multi_patient,
        emp_comments: this.parentTextareaValue,
        is_sample_collected: aptData.is_sample_collected,
        patients: [
          {
            pat_available: this.pat_available,
            rel_id: this.patientData.rel_id
          }
        ]
      }
      this.$store.dispatch("httpPost", { uri: this.api, body: obj }).then(response => {
        if (response && response.status === 1000) {
          this.$store.dispatch('SET_ALERTMESSAGE', { 'msg': response.message, class: 'sa-a-success' })
          this.$router.push('/appointments')
        } else {
          this.$store.dispatch('SET_ALERTMESSAGE', { 'msg': response.message, class: 'sa-a-danger' })
        }
      })
    },
    ptnDetails() {
      this.api = this.utid === 4 ? `${lab_url}/appointment/id` : `${nurse_url}/appointment/id`
      let obj = {
        apnt_id: this.$route.query.apnt_id,
        is_multi_patient: this.$route.query.is_multi_patient
      }
      this.$store.dispatch("httpPost", { uri: this.api, body: obj }).then(response => {
        if (response && response.status === 1000) {
          this.aptDetails = response.data
          this.patientData = response.data.patientData
        } else {
          this.$store.dispatch('SET_ALERTMESSAGE', { 'msg': response.message, class: 'sa-a-danger' })
        }
      })
    }
  },
};
</script>
